import {sprintf} from '@/angular/libs/sprintf';

/*
* A function that converts seconds into hours, minutes, and seconds when the unit is seconds
*/
export function formatSecondsToReadableTime(seconds, locale = 'en') {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    const format = (value, unit) => {
        return new Intl.NumberFormat(locale, {
            style: 'unit',
            unit,
            unitDisplay: 'narrow',
        }).format(value);
    };

    const parts = [];
    if (hrs > 0) parts.push(format(hrs, 'hour'));
    if (mins > 0) parts.push(format(mins, 'minute'));
    if (secs > 0 || parts.length === 0) parts.push(format(secs, 'second'));

    return parts.join(' ');
}
export function getValueFormatter(prefix, suffix, digits=2) {
    return function(value, onlyPositive=false){
        if (onlyPositive){
            value = Math.abs(value)
        }

        const valueFormatted = value.toFixed(digits).toString()
        return (prefix ? prefix + ' ' : '') + valueFormatted + (suffix ? ' ' + suffix : '');
    }
}

export function getValueFormatterWithMeta(meta){
    return function (value) {
        if (meta && meta.formatWithUnit) {
            return sprintf(meta.formatWithUnit.replace('F', 'f'), value);
        } else {
            return value;
        }
    }
}

export function getValueFormatterWithDecimals(prefix, suffix) {
    return function(value, onlyPositive=false){
        if (onlyPositive){
            value = Math.abs(value)
        }

        const roundedValue = Math.round((value + Number.EPSILON) * 10000) / 10000; // use Number.EPSILON to avoid floating point errors

        // Split the value into integer and decimal parts
        let [integerPart, decimalPart] = roundedValue.toString().includes('.')
        ? roundedValue.toString().split('.')
        : roundedValue.toString().split(',');

        decimalPart = (decimalPart || "").padEnd(2, '0'); // Add minimum 2 decimal places

        const valueFormatted = `${integerPart}.${decimalPart}`;

        return (prefix ? prefix + ' ' : '') + valueFormatted + (suffix ? ' ' + suffix : '');
    }
}
